/**
 * Maps ISO Arabic (`ar`) to the JSON filename used in this app (`sa.json`).
 * ngx-translate loads `./assets/i18n/{lang}.json`; we ship `sa.json`, not `ar.json`.
 */
export function translateFileLang(lang: string | null | undefined): string {
    if (lang === 'ar') return 'sa';
    return lang || 'en';
}
